<template>
  <div class="container profile">
    <!-- <div class="row">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3">
              <router-link to="/">{{$t('profile.breadcrumb_1')}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">
              {{$t('profile.breadcrumb_2')}}
            </li>
          </ol>
        </nav>
      </div>
    </div> -->
    <div v-if="isLoading" class="text-center">
      <mainloader />
    </div>
    <div v-else class="row profilePage">
      <div class="col-12 col-md-3">
        <div class="row">
          <div class="col">
            <div class="card">
              <div class="card-body">
                <div class="row justify-content-center">
                  <div class="col-12 text-center">
                    <input type="file" class="d-none" id="logo" 
                    @change="uploadlogo($event.target.files)">
                    <label for="logo">
                      <div class="logo mouse-hand" v-if="user.avatar">
                        <img :src="MEDIA_URL+user.avatar" class="img_Profile" alt="">
                      </div>
                      <i v-else class="fa-solid mouse-hand fa-circle-user logoProfile img_Profile"></i>
                    </label>
                    <div class="py-2 almarai-bold">{{ user.name }}</div>
                    <div class="row justify-content-center" v-if="user.isFeatured">
                      <div class="col-auto owner">
                        <img src="/assets/images/icons/star.png" class="max-16" alt="">
                        <span class="mx-1">{{$t('profile.distinguishedOwner')}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card mt-2">
              <div class="card-body">
                <h6 class="blue_Text">{{$t('currentAccount')}}</h6>
                <div class="row">
                  <div class="col-auto">
                    <img src="/assets/images/icons/profile-circle.png" class="max-22" alt="">
                  </div>
                  <div class="col almarai-bold p-0 fonttext-14">
                    <!-- {{$t('personalAccount')}} -->
                    <div>
                      <span>{{GET_USER_DATA.accountType == 'personal' ? 'شخصي': GET_USER_DATA.accountType == 'company' ? 'منشأة عقارية' : 'وسيط عقاري'}}</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-9">
                    <div class="btn_changeAccount" @click.prevent="changeAccount">
                      <span>{{$t('editAccount_Details')}}</span>
                      <span class="mx-2">
                        <img src="/assets/images/icons/edit-2.png" class="max-20" alt="">
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col">
            <div class="card mt-2">
              <div class="card-body">
                <ul class="dropdownProfile">
                  <li class="dropdown-item">
                    <img src="/assets/images/icons/candle-2.png" alt="" class="ms-2 max-20" />
                    <span class="">{{$t('controlPanel')}}</span>
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                    <i v-else class="fa-solid fa-chevron-right"></i>
                  </li>

                  <li class="dropdown-item">
                    <router-link to="/previewlist">
                      <img src="/assets/images/icons/calendar-edit.png" alt="" class="ms-2 max-20" />
                      <span class="">{{$t('previews')}}</span>
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                      <i v-else class="fa-solid fa-chevron-right"></i>
                    </router-link>
                  </li>

                  <li class="dropdown-item">
                    <img src="/assets/images/icons/building.png" alt="" class="ms-2 max-20" />
                    <span class="">{{$t('realEstate_Comparison')}}</span>
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                    <i v-else class="fa-solid fa-chevron-right"></i>
                  </li>

                  <li class="dropdown-item">
                    <router-link to="/favorite">
                      <img src="/assets/images/icons/heart.png" alt="" class="ms-2 max-20" />
                      <span class="">{{$t('nav.favoriteProperties')}}</span>
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                      <i v-else class="fa-solid fa-chevron-right"></i>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row">
          <div class="col">
            <div class="card mt-2">
              <div class="card-body">
                <ul class="dropdownProfile">
                  <li class="dropdown-item">
                    <router-link to="/favorite">
                      <img src="/assets/images/icons/heart.png" alt="" class="ms-2 max-20" />
                      <span class="">{{$t('nav.favoriteProperties')}}</span>
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                      <i v-else class="fa-solid fa-chevron-right"></i>
                    </router-link>
                  </li>

                  <li class="dropdown-item">
                    <router-link to="/mybankaccount">
                      <img src="/assets/images/icons/bank_P.png" alt="" class="ms-2 max-20" />
                      <span class="">{{$t('nav.bankAccount')}}</span>
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                      <i v-else class="fa-solid fa-chevron-right"></i>
                    </router-link>
                  </li>

                  <li class="dropdown-item">
                    <router-link to="/financialtransactions">
                      <img src="/assets/images/icons/moneys_icon.png" alt="" class="ms-2 max-20" />
                      <span class="">{{$t('nav.financialTransactions')}}</span>
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left"></i>
                      <i v-else class="fa-solid fa-chevron-right"></i>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-9 accountDetailsForm">
        <div class="text-center" v-if="hasError"> 
          <errorAlert :alertMessage="message" :errorNumber="errorNumber" /> 
        </div>
        <!-- begin: account Details -->
        <div class="card" v-if="accountType == 'accountDetails'">
          <div class="card-body">
            <h6 class="almarai-bold">{{$t('accountDetails')}}</h6>
            <div class="row justify-content-center">
              <div class="col-12 accountDetails">
                <div class="row pt-3">
                  <div class="col">
                    <label for="" class="small-Font">{{$t('profile.fullName')}}</label>
                    <input v-model="fullName" disabled id="name" class="form-control" />
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col">
                    <label for="" class="small-Font">{{$t('profile.email')}}</label>
                    <input v-model="email" disabled id="email" class="form-control" />
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col">
                    <label for="" class="small-Font">{{$t('profile.Absher_mobile')}}</label>
                    <input v-model="mobile" disabled  @input="mobile = mobile.replace(/[^0-9]/g, '')"
                      maxlength="10" class="form-control" 
                    />
                  </div>
                </div>

                <!-- <div class="row py-3 justify-content-center">
                  <div class="col-12 col-md-6 text-center">
                    <div v-if="loading" class="text-center"> <loader /> </div>
                    <div v-else @click.prevent="setProfile" class="btn-gold">{{$t('profile.Save_Changes')}}</div>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="row py-3">
              <div class="col-auto" @click.prevent="changePasswordFN">
                <div class="btn-Green-3E">
                  <span><img src="/assets/images/icons/edit-1.png" class="max-22" alt=""></span>
                  <span class="mx-2">{{$t('profile.changePassword')}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end: account Details -->

        <!-- begin: update Account -->
        <div class="card" v-if="accountType == 'updateAccount'">
          <div class="card-body">
            <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item mx-3 mouse-hand" @click.prevent="prevPage">
                  {{$t('myAccount')}}
                </li>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
                <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">
                  {{$t('accountDetails')}}
                </li>
              </ol>
            </nav>
            <!-- <h6 class="almarai-bold">{{$t('accountDetails')}}</h6> -->
            <div class="row justify-content-center">
              <div class="col-12 accountDetails">
                <div class="row pt-3">
                  <div class="col">
                    <label for="" class="small-Font">{{$t('profile.fullName')}}</label>
                    <input v-model="fullName" id="name" class="form-control" />
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col">
                    <label for="" class="small-Font">{{$t('profile.email')}}</label>
                    <input v-model="email" id="email" class="form-control" />
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col">
                    <label for="" class="small-Font">{{$t('profile.Absher_mobile')}}</label>
                    <input v-model="mobile"  @input="mobile = mobile.replace(/[^0-9]/g, '')"
                      maxlength="10" class="form-control" 
                    />
                  </div>
                </div>

                <div class="row py-3 justify-content-center">
                  <div class="col-9 col-md-4 text-center">
                    <div v-if="loading" class="text-center"> <loader /> </div>
                    <div v-else @click.prevent="setProfile" class="btn-green">{{$t('profile.Save_Changes')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row pb-3">
              <div class="col-auto">
                <div class="btn-Green-3E">
                  <span><img src="/assets/images/icons/edit-1.png" class="max-22" alt=""></span>
                  <span class="mx-2">{{$t('profile.changePassword')}}</span>
                </div>
              </div>
            </div> -->
          </div>
          <!-- <ul class="nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item space py-2 list_Style" role="presentation">
              <button class="nav-link active btn-orange" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">{{$t('profile.accountDetails')}}</button>
            </li>
            <li class="nav-item space py-2 list_Style" role="presentation">
            </li>
          </ul> -->
        </div>
        <!-- end: update Account -->
        <!-- begin: change password -->
        <div class="row justify-content-center py-4" v-if="accountType == 'changePassword'">
          <div class="col-12">
            <div class="row justify-content-center">
              <div class="col-12 col-lg-12">
                <errorAlert v-if="passwordError" :alertMessage="message" :errorNumber="errorNumber" />
                <success v-if="succesfuly" :message="succesMessage" />
              </div>
            </div>
            <div class="card blog-card">
              <div class="card-body accountDetails">
                <nav class="pb-2">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item mx-3 mouse-hand" @click.prevent="prevPage">
                      {{$t('myAccount')}}
                    </li>
                    <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                    <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
                    <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">
                      {{$t('profile.changePassword')}}
                    </li>
                  </ol>
                </nav>
                <form action="">
                  <div class="row">
                    <div class="col position-R">
                      <label for="">{{$t('changePassword.title_2')}}</label>
                      <input :type="fieldType" placeholder="***************" v-model="oldPassword"
                        class=" form-control input-style" maxlength="50"
                      >
                      <span v-if="fieldType == 'password'" @click.prevent="togglePassword" class="changePassword-eyes">
                        <i class="fa-regular fa-eye-slash"></i>
                      </span>
                      <span v-else  @click.prevent="togglePassword" class="changePassword-eyes">
                        <i class="fa-regular fa-eye"></i>
                      </span>
                      
                    </div>
                  </div>
                  <div class="row pt-3">
                    <div class="col position-R">
                      <label for="">{{$t('changePassword.title_3')}}</label>
                      <input :type="toggleType" v-model="newPassword" placeholder="***************" maxlength="50"
                        @input="checkPasswordRules" class="input-style form-control" @focus="showPasswordRules = true"
                      >
                      <span v-if="toggleType == 'password'" @click.prevent="togglefiledType" class="changePassword-eyes">
                        <i class="fa-regular fa-eye-slash"></i>
                      </span>
                      <span v-else  @click.prevent="togglefiledType" class="changePassword-eyes">
                        <i class="fa-regular fa-eye"></i>
                      </span>
                      <ul v-show="showPasswordRules" class="password-rules mt-2 list-unstyled">
                        <li :class="{ 'text-success': passwordRules.length }">At least 8 characters long</li>
                        <li :class="{ 'text-success': passwordRules.uppercase }">Contains 1 uppercase character</li>
                        <li :class="{ 'text-success': passwordRules.numberOrSymbol }">Contains 1 number or symbol</li>
                      </ul>
                    </div>
                  </div>
                  <div class="row py-3 justify-content-center">
                    <div class="col-9 col-md-4 text-center">
                      <div v-if="isLoader" class="text-center">
                        <loader />
                      </div>
                      <button v-else @click.prevent="changePassword" class="btn-Green-3E form-control">{{$t('changePassword.title_4')}}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- end: change password -->


        <!-- <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
            <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
              <div class="row justify-content-center">
                <div class="col-12 col-lg-12">
                  <success v-if="succesfuly" :message="succesMessage" />
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-12 col-lg-12">
                  <errorAlert v-if="passwordError" :alertMessage="message" :errorNumber="errorNumber" />
                </div>
              </div>
              <div class="row justify-content-center py-4">
                <div class="col-12 col-lg-8">
                  <div class="card blog-card card-groundcolor">
                    <div class="card-body">
                      <form action="">
                        <div class="row">
                          <div class="col">
                            <label for="">{{$t('changePassword.title_2')}}</label>
                            <input :type="fieldType" placeholder="***************" v-model="oldPassword"
                              class=" form-control input-style" maxlength="50"
                            >
                            <span v-if="fieldType == 'password'" @click.prevent="togglePassword" class="eyes-Icons-2">
                              <i class="fa-regular fa-eye-slash"></i>
                            </span>
                            <span v-else  @click.prevent="togglePassword" class="eyes-Icons-2">
                              <i class="fa-regular fa-eye"></i>
                            </span>
                            
                          </div>
                        </div>
                        <div class="row pt-3">
                          <div class="col position-R">
                            <label for="">{{$t('changePassword.title_3')}}</label>
                            <input :type="toggleType" v-model="newPassword" placeholder="***************" maxlength="50"
                              @input="checkPasswordRules" class="input-style form-control" @focus="showPasswordRules = true"
                            >
                            <span v-if="toggleType == 'password'" @click.prevent="togglefiledType" class="changePassword-eyes">
                              <i class="fa-regular fa-eye-slash"></i>
                            </span>
                            <span v-else  @click.prevent="togglefiledType" class="changePassword-eyes">
                              <i class="fa-regular fa-eye"></i>
                            </span>
                            <ul v-show="showPasswordRules" class="password-rules mt-2 list-unstyled">
                              <li :class="{ 'text-success': passwordRules.length }">At least 8 characters long</li>
                              <li :class="{ 'text-success': passwordRules.uppercase }">Contains 1 uppercase character</li>
                              <li :class="{ 'text-success': passwordRules.numberOrSymbol }">Contains 1 number or symbol</li>
                            </ul>
                          </div>
                        </div>
                        <div class="row py-3 justify-content-center">
                          <div class="col-12 col-md-6 text-center">
                            <div v-if="isLoader" class="text-center">
                              <loader />
                            </div>
                            <button v-else @click.prevent="changePassword" class="buttonStyle padding-style form-control">{{$t('changePassword.title_4')}}</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">...</div>
            <div class="tab-pane fade" id="pills-disabled" role="tabpanel" aria-labelledby="pills-disabled-tab" tabindex="0">...</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: "profile",

  data() {
    return {
      hasError: false,
      message: "",
      errorNumber: 0,
      isLoading: false,
      email: null,
      fullName: "",
      mobile: null,
      user: {},
      logo: "",
      loading: false,
      userName: "",
      dataLoading: false,
      accountType: "accountDetails",
      rows: [],
      value: {},
      loader: true,
      items: [],
      ownerStatus: {},
      currentPage: 1,
      number: '',
      fieldType: 'password',
      toggleType: 'password',
      userLang: 'ar',
      showPasswordRules: false,
      passwordRules: {
        length: false,
        uppercase: false,
        numberOrSymbol: false,
      },
      succesfuly: false,
      succesMessage: '',
      passwordError: false,
      isLoader: false,
      oldPassword: "",
      newPassword: "",
    };
  },
  computed: {
    ...mapGetters(['MEDIA_URL','GET_USER_DATA','GET_USER','ISLOADING'])
  },

  methods: {
    getProfile() {
      this.isLoading = true;
      this.hasError = false;
      this.$http.get("/api/users/getPorfile").then((res) => {
        // console.log(res);
        this.user = res.data.user;
        this.fullName = res.data.user.name;
        this.email = res.data.user.email;
        this.mobile = res.data.user.abshirMobile;
        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    
    uploadlogo(files){
      this.logo = files[0];
    },

    setProfile(){
      this.hasError = false;
      this.loading = true;
      const formData = new FormData();
      formData.append('name', this.fullName)
      if(this.email && this.email.trim() != '')
        formData.append('email', this.email);
      if(this.mobile && this.mobile.trim() != '')
        formData.append('abshirMobile', this.mobile);
      formData.append('avatar', this.logo)
      this.$http.post("/api/users/setPorfile",formData).then(res => {
        this.isLoading = true;
        this.getProfile();
        // this.fullName = ""
        // this.email = ""
        // this.mobile = ""
        window.scroll(0,0);
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      });
    },

    update(){
      document.getElementById("numberOnly").addEventListener("input", function(e) {
        this.value = this.value.replace(/[^0-9]/g, ''); // remove anything that's not a number
      });
    },

    togglePassword(){
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password';
    },
    togglefiledType(){
      this.toggleType = this.toggleType === 'password' ? 'text' : 'password';
    },

    checkPasswordRules() {
      this.showPasswordRules = true;
      this.passwordRules.length = this.newPassword.length >= 8;
      this.passwordRules.uppercase = /[A-Z]/.test(this.newPassword);
      this.passwordRules.numberOrSymbol = /[0-9!@#$%^&*]/.test(this.newPassword);
    },

    changePassword(){
      this.passwordError = false;
      this.succesfuly = false;
      this.isLoader = true;
      this.$http.post("/api/users/changePassword",{
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
      }).then(res => {
        // console.log(res);
        setTimeout(()=> {
          this.succesMessage = this.$t('changePassword.confirmMessage');
          this.succesfuly = true;
          this.isLoader = false;
        },500)
        this.oldPassword = '';
        this.newPassword = '';
      }).catch(err => {
        // console.log(err);
        this.isLoader = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.passwordError = true;
        window.scroll(0,0);
      });
    },

    changeAccount(){
      console.log('djfhklsdajfljsdlk;fjsd');
      this.accountType = "updateAccount";
    },

    changePasswordFN(){
      this.accountType = "changePassword";
    },

    prevPage() {
      this.accountType = "accountDetails"
    },
    

  },
  created() {
    this.getProfile();
    // if(this.ISLOADING && !this.GET_USER){
    //   this.$router.replace({path: '/login'});
    // }
    this.userLang = localStorage.getItem('lang') ??  'ar';
    window.scrollTo({top:0, behavior: 'smooth'});
  },
};
</script>